import * as React from 'react';
import { translation } from 'easit--localization';

export interface IActionsProps {
    back?: () => void;
    refresh: () => void;
}

export const Actions: React.StatelessComponent<IActionsProps> = (props) => {

    return <div className={"actions d-flex"}>
        {props.back &&
            <a className="p-2 betdetail-action" onClick={props.back} title={translation().back}>
                <i className={'fas fa-long-arrow-alt-left'} />
            </a>
        }
        <a className="p-2 betdetail-action" onClick={props.refresh} title={translation().refresh}>
            <i className={'fas fa-sync-alt'} />
        </a>
    </div>
}
